import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UtilityService } from './../../services';

@Component({
  selector: 'app-input-field',
  templateUrl: './global.input.component.html'
})
export class GlobalInputComponent {

  @Output() modelChange = new EventEmitter<any>();
  @Input() label: string;
  @Input() name = '';
  @Input() decimalInput = false;
  @Input() uppercase = false;
  @Input() decimalPlaces = 3;
  @Input() restrictedTo: string = null;
  @Input() maxlength = '';
  @Input() errMsg?: string;
  @Input() hint?: string;
  @Input() placeholder?: string;
  @Input() type?: string;
  @Input() isAmount = false;
  @Input() control: FormControl;
  @Input() tooltip;

  hide = true;

  constructor(private util: UtilityService) { } //private util: UtilityService

  isRequired() {
    return this.util.isRequired(this.control);
  }
  emitChange(event) {
    this.modelChange.emit(event);
  }

}
